import { Checkbox } from "@mantine/core";
import { useTranslation } from "react-i18next";
import {
  handleNoIdProvidedChange,
  isNoIdProvided,
} from "../helpers/clientIdentity";

const NoIdProvidedCheckbox = ({
  form,
  value: _value,
  onChange,
  checked: _checked,
  label,
  ...props
}) => {
  const { t } = useTranslation();

  return (
    <Checkbox
      {...props}
      label={label ?? t("No ID provided")}
      checked={isNoIdProvided(form.values?.idType)}
      onChange={(event) => {
        handleNoIdProvidedChange(event.currentTarget.checked, form);
        onChange?.(event);
      }}
      mb={props.mb ?? "sm"}
    />
  );
};

export default NoIdProvidedCheckbox;
